import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Auth guard that redirects unauthenticated users to login
 * Preserves the original URL for deep linking after authentication
 */
export const authGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const auth = inject(Auth);
  const router = inject(Router);

  return new Observable<boolean | UrlTree>((observer) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        observer.next(true);
      } else {
        // Store the attempted URL for redirecting after login
        const urlTree = router.createUrlTree(['/auth/login'], {
          queryParams: { returnUrl: state.url },
        });
        observer.next(urlTree);
      }
      observer.complete();
    });

    return () => unsubscribe();
  });
};
